export enum TRACKING_CATEGORIES {
  CONTACT = 'CO',
  GENERAL = 'GI',
  LANDING_PAGE = 'LP',
  NAVIGATION = 'NV',
  USER_ACCOUNT = 'UA',
}

export enum DATA_LAYER_EVENTS {
  ADD_TO_CART = 'product.interact.manual.click.addToCart',
  CART_ERROR = 'cart.load.auto.error.orderError',
  CART_LOAD = 'cart.load.auto.dataLayer.load',
  CART_NEXT = 'cart.interact.manual.nextStep',
  CASH_ADDON_SUCCESS = 'user.interact.manual.success.cashAddOn',
  DATA_ADDON_SUCCESS = 'user.interact.manual.success.dataAddOn',
  UK_DATA_PASS_ADDON_SUCCESS = 'user.interact.manual.success.ukDataPassAddOn',
  EU_DATA_PASS_ADDON_SUCCESS = 'user.interact.manual.success.euDataPassAddOn',
  CHANGE_PLAN_UPGRADE = 'user.interact.manual.success.planUpgrade',
  CHANGE_PLAN_DOWNGRADE = 'user.interact.manual.success.planDowngrade',
  FORM_ERROR = 'form.interact.auto.error.formError',
  FORM_SUCCESS = 'form.interact.auto.success.formSuccess',
  FORM_START = 'form.interact.auto.success.formStart',
  FORM_SUBMIT = 'form.interact.manual.click.formSubmit',
  GROUP_ACCEPT = 'user.interact.auto.success.groupsAcceptInvite',
  GROUP_REJECT = 'user.interact.auto.success.groupsRejectInvite',
  LOGIN_SUCCESS = 'user.interact.auto.success.loginSuccess',
  MODULE_CLICK = 'moduleItem.interact.manual.click',
  MODULE_LOAD = 'module.load.auto.dataLayer.load',
  ORDER_SUBMIT = 'cart.interact.manual.submit.orderSubmit',
  PRODUCT_LOAD = 'product.load.auto.dataLayer.load',
  PRODUCT_VIEW = 'product.interact.manual.view',
  REGISTRATION_SUCCESS = 'user.interact.auto.success.regSuccess',
  RENEW_SUCCESS = 'user.interact.manual.success.planRenewal',
  SCREEN_LOAD = 'screen.load.auto.dataLayer.load',
  SUBMIT_PAC = 'user.interact.manual.submitPAC',
  SUBMIT_STAC = 'user.interact.manual.submitSTAC',
  TRANSACTION_SUCCESS = 'transaction.load.auto.success.transactionSuccess',
  UPDATE_MARKETING_PREFS = 'user.interact.manual.success.marketingPreferences',
  UPDATE_AUTO_RENEW = 'user.interact.manual.success.autoRenew',
  UPDATE_ADULT_CONTENT = 'user.interact.manual.success.adultContent',
  SELECT_COUNTRY = 'search.load.auto.search.resultsSelect',
  PLATFORM_ERROR = 'platform.messaging.auto.dataLayer.error',
  SET_PORTING_PREF = 'user.interact.manual.set.portingPref',
  UPDATE_PORTING_PREF = 'user.interact.manual.update.portingPref',
  HERO_STRING = 'hero-view-our-plans',
  ADD_DELIVERY = 'user.interact.manual.addDelivery',
  REQUEST_ACTIVATION = 'user.interact.member.requestActivation',
}

export const CHECKOUT_TYPES = {
  PAYPAL: 'paypal-checkout',
  REGULAR: 'regular-checkout',
  APPLE_PAY: 'apple-pay-checkout',
  GOOGLE_PAY: 'google-pay-checkout',
}

export enum DATA_LAYER_FORM_NAMES {
  ADULT_CONTENT_CONFIRM = 'adult-content-confirm',
  CREATE_ACCOUNT = 'create-account-form',
  CREATE_MEMBER_ACCOUNT = 'create-member-account-form',
  FAMILY_PLAN_EDIT_ADDRESS = 'family-plan-edit-address',
  FAMILY_PLAN_ADD_ADDRESS = 'family-plan-add-address',
  FAMILY_PLAN_TERMS_CONDITIONS = 'family-plan-terms-conditions',
  FAMILY_PLAN_VALIDATE_PORT_IN = 'family-plan-validate-port-in',
  ORDER_PAY = 'orderPay',
  GROUP_ADD_NEW_SIM = 'group-add-new-sim',
  GROUP_INVITE_EXISTING = 'group-invite-existing-customer',
  GROUP_TERMS = 'groupTermsForm',
  LOGIN = 'login',
  COMMUNITY_LOGIN = 'community-login',
  OTP = 'otp',
  PAYPAL_FORM = 'paypal-form',
  SIH_ACTIVATION = 'sim-in-hand-journey-activate',
  WEB_ACTIVATION = 'web-journey-activate',
  // Two different leave forms
  SWITCHING_LEAVE_FORM = 'leavingForm',
  TERMINATE_LEAVE_FORM = 'leave-form',
  TOKEN_CREATE_ACCOUNT = 'tokenCreateAccountForm',
  UPDATE_ACCOUNT = 'update-account-form',
  UPDATE_MARKETING_PREFS = 'updateMarketingPreferences',
  MARKETING_PREFS = 'marketing-preferences',
  MARKETING_PREFS_UPDATE_BANNER = 'marketing-prefs-update-banner',
  MARKETING_PREFS_CARD = 'marketing-preferences-card',
  ADDON_HELPER_TOOL_REASONS = 'add-on-helper-reasons',
  SWITCHING_SERVICES = 'switching-your-services-agreement',
  RESUME_PLAN_FP = 'resume-plan-fp',
  RESTART_PLAN_FP = 'restart-plan-fp',
  RESTART_PLAN_PAYMENT = 'restart-plan-payment',
  CHANGE_PLAN_PAYMENT = 'change-plan-payment',
  COMPLAINTS = 'onlineComplaintsForm',
}

export enum DATA_LAYER_JOURNEY_TYPES {
  CHECKOUT_PAYPAL = 'paypal-checkout',
  CHECKOUT_REGULAR = 'regular-checkout',
  CHECKOUT_STANDARD = 'standard-checkout',
  CHECKOUT_GROUPS = 'groups-checkout',
  CHECKOUT_ADDON = 'add-on-checkout',
  CHECKOUT_CHANGE_PLAN = 'change-plan-checkout',
  CHECKOUT_GROUP_CHANGE_PLAN = 'group-change-plan',
  CHECKOUT_MANUAL_RENEWAL = 'manual-renewal-checkout',
  CHECKOUT_FAMILY_PLAN_RESTART = 'plan-restart',
}

export enum DATA_LAYER_MODULE_POSITIONS {
  SOCIAL_SHARE = 'order-confirmation-page-end',
  ORDER_CONFIRMATION = 'order-confirmation-order-section-end',
  DISMISSIBLE_CARDS = 'dashboard-whats-new-section',
  LEAVERS_JOURNEY = 'leave-smarty-page-end',
  OFFER_INFO_BANNER = 'dashboard-offers-available-banner',
  PROMO_BANNER = 'dashboard-top-banner',
  TOP = 'top',
  BELOW_SMARTY = 'below-smarty',
  BELOW_DATA_ONLY = 'below-data-only',
  HERO_SECTION = 'hero-section',
  POP_UP = 'pop-up',
  HOMEPAGE = 'homepage',
}

export enum DATA_LAYER_MODULE_TYPES {
  DISMISSIBLE_CARDS = 'dismissible-cards',
  NON_DISMISSIBLE_CARDS = 'non-dismissible-cards',
  DISMISSIBLE_CARD = 'dismissible-card',
  NON_DISMISSIBLE_CARD = 'non-dismissible-card',
  GROUP_PLANS = 'group-plans',
  GROUP_PLANS_SMARTY = 'all-tab-smarty-plans-group',
  GROUP_PLANS_DATA_ONLY = 'all-tab-data-only-plans-group',
  GROUP_PLANS_MONEY_BACK = 'all-tab-money-back-plans-group',
  CHANGE_PLAN_CURRENT_OFFERS = 'plan-change-current-offers',
  CHANGE_PLAN_SOCIAL_TARIFF = 'plan-change-social-tariff',
  CHANGE_PLAN_MONEY_BACK = 'plan-change-data-discount',
  CHANGE_PLAN_DATA_ONLY = 'plan-change-data-only',
  CHANGE_PLAN_VOICE_PLANS = 'plan-change-voice-plans',
  MANUAL_RENEWAL_CURRENT_OFFERS = 'manual-renewal-current-offers',
  MANUAL_RENEWAL_SOCIAL_TARIFF = 'manual-renewal-social-tariff',
  MANUAL_RENEWAL_MONEY_BACK = 'manual-renewal-data-discount',
  MANUAL_RENEWAL_DATA_ONLY = 'manual-renewal-data-only',
  MANUAL_RENEWAL_VOICE_PLANS = 'manual-renewal-voice-plans',
  OFFER_INFO_BANNER = 'offers-available-banner',
  MULTIPLE_OFFERS_BANNER = 'multiple-offers-banner',
  OFFERS_AVAILABLE = 'new-offers-available',
  PROMO_BANNER = 'personalised-banner',
  PROMOTION = 'promotion',
  PRODUCT = 'product',
  PRODUCTS = 'products',
  BANNER = 'banner',
  AGREEMENT_PANEL = 'agreement-panel',
  HELPER_TOOL_USE_PLAN_ABROAD = 'helper-tool-use-plan-abroad',
  HELPER_TOOL_INTERNATIONAL_CALLS = 'helper-tool-international-calls',
  HELPER_TOOL_CHARGEABLE_NUMBERS = 'helper-tool-chargeable-numbers',
  HELPER_TOOL_SHORTCODES = 'helper-tool-shortcodes',
  HELPER_TOOL_MORE_DATA_IN_UK = 'helper-tool-more-data-in-uk',
  HELPER_TOOL_MORE_DATA_PASSES_IN_UK = 'helper-tool-more-data-passes-in-uk',
  HELPER_TOOL_ROAMING_IN_EU_DATA = 'helper-tool-roaming-in-eu-data',
  HELPER_TOOL_ROAMING_IN_EU_DATA_PASSES = 'helper-tool-roaming-in-eu-data-passes',
  UPSELL = 'upsell',
  FAMILY_PLAN = 'family-plan',
}

export enum DATA_LAYER_SCREEN_TYPES {
  ACCOUNT = 'account',
  CHECKOUT = 'checkout',
  GENERAL_INFO = 'general-info',
  HOMEPAGE = 'homepage',
  PRODUCT_LIST = 'product-list',
  PRODUCT_DETAILS = 'product-details',
  LANDING_PAGE = 'landing-page',
  SUPPORT_HELP = 'support-help',
  DOWNLOAD = 'download',
  ERROR = 'error',
}

export enum FORM_ERRORS {
  LOGIN_FAILURE = 'Email or password is incorrect',
  TOO_MANY_REQUESTS = "You've tried to sign in too many times with an incorrect account or password. Please try again in 5 minutes",
  MAX_SIM_LIMIT = 'The maximum SIM request limit has been reached. Contact customer support for further help.',
  SLOT_LOCK_PERIOD = 'Your previous request is still in progress. Please try again later.',
  NUMBER_OF_NEW_MEMBERS = 'The maximum number of members in a group without an owner should be' +
    ' seven.',
  NOT_ELIGIBLE = 'Customer is not eligible to be invited',
  DUPLICATE_ADDRESSES = 'Address matches one you’ve already entered. Please update and try again.',
}

export enum ORDER_TYPES {
  CHANGE_PLAN = 'change-plan',
  GROUP_CHANGE_PLAN = 'group-change-plan',
  GROUPS_JOURNEY_ULFP = 'groups-journey-ulfp',
  MANUAL_RENEWAL = 'manual-renewal',
}
